import { Box, Typography } from "@mui/material";
import { Grid } from "@mui/material";
import DigitalRxLogo from "../../../images/icons/DRxLogo.svg";
import IDMELogo from "../../../images/icons/IDme.svg";
import { useDispatch } from "react-redux";
import { setSetup, setSteps } from "../../../Redux/Slice/IdmeSlice";
import { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import { get2FASetups } from "../../../Apis/Idme2FA";

export default function MFASetupPreference({
  userUuidData,
  isBack,
  setIsBack,
  setMfaSetupsData,
}: any) {
  const dispatch = useDispatch();
  const [pushData, setPushData] = useState([]);
  const [generatorData, setGeneratorData] = useState([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  useEffect(() => {
    const fetch2FASetups = async () => {
      try {
        const params: any = new URLSearchParams();
        params.append("userUUID", localStorage.getItem("userIdmeUuid"));
        const result = await get2FASetups(params);
        if (result.status === 200) {
          let generatorData = result?.data?.filter(
            (data: any) => data.option === "generator"
          );
          let pushData = result?.data?.filter(
            (data: any) => data.option === "push"
          );

          if (userUuidData?.savedPreferenceForSetUp === 0) {
            dispatch(setSetup("0"));
            if (!isBack) {
              dispatch(setSteps("three"));
            }
          } else if (userUuidData?.savedPreferenceForSetUp === 1) {
            dispatch(setSetup("1"));
            if (!isBack) {
              dispatch(setSteps("three"));
            }
          } else {
            if (result?.data?.length === 1 && generatorData?.length === 1) {
              dispatch(setSetup("1"));
              if (!isBack) {
                dispatch(setSteps("three"));
              }
            } else if (result?.data?.length === 1 && pushData?.length === 1) {
              dispatch(setSetup("0"));
              if (!isBack) {
                dispatch(setSteps("three"));
              }
            }
          }
          setPushData(pushData);
          setGeneratorData(generatorData);
          setMfaSetupsData(result?.data);
          setLoading(false);
          setErrorMessage(null);
        } else {
          setPushData([]);
          setGeneratorData([]);
          setMfaSetupsData([]);
          setLoading(false);
          setErrorMessage(result?.data?.message);
        }
      } catch (error: any) {
        setErrorMessage("Something went wrong, please try again later!");
        setPushData([]);
        setGeneratorData([]);
        setMfaSetupsData([]);
        setLoading(false);
      }
    };
    fetch2FASetups();
  }, []);

  if (loading) {
    return (
      <>
        <Grid container className="logos" height={384}>
          <Grid item>
            <CircularProgress color="primary" />
          </Grid>
        </Grid>
      </>
    );
  }

  if (errorMessage) {
    return (
      <>
        <Grid container className="logos" flexDirection={"column"} height={384}>
          <Grid item>
            <Box className="logos">
              <img src={IDMELogo} alt="ID.me" height={30} />
              <Typography
                component={"div"}
                color={"slategrey"}
                margin={0}
                padding={0}
                variant={"h3"}
                fontWeight={600}
              >
                +
              </Typography>
              <img src={DigitalRxLogo} alt="Digital_Rx" height={30} />
            </Box>
          </Grid>
          <Grid item>
            <Typography variant="h5" color={"error"}>
              {errorMessage}
            </Typography>
          </Grid>
        </Grid>
      </>
    );
  }
  return (
    <>
      <Grid container spacing={2} height={400}>
        <Grid item xs={12}>
          <Box className="logos">
            <img src={IDMELogo} alt="ID.me" height={30} />
            <Typography
              component={"div"}
              color={"slategrey"}
              margin={0}
              padding={0}
              variant={"h3"}
              fontWeight={600}
            >
              +
            </Typography>
            <img src={DigitalRxLogo} alt="Digital_Rx" height={30} />
          </Box>
          <Box className="logos">
            <Typography
              color="primary"
              variant={"subtitle1"}
              fontWeight={600}
              textAlign={"center"}
            >
              Choose a multi-Factor authentication (MFA) Method
            </Typography>
          </Box>
          <Box className="logos" marginTop={1}>
            <Typography variant={"body2"} textAlign={"center"}>
              You have the following MFA methods enabled. Choose one to finish
              signing in
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} textAlign="center">
          <Box className="iconCheckboxes">
            {pushData?.length > 0 && (
              <Box
                className={"iconCheckbox"}
                onClick={() => {
                  dispatch(setSetup("0"));
                  dispatch(setSteps("three"));
                  setIsBack(false);
                }}
              >
                <svg
                  className="icon"
                  width="69"
                  height="69"
                  viewBox="0 0 69 69"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M33.4402 51.0409V49.5409C33.0581 49.5409 32.6904 49.6867 32.4122 49.9486L33.4402 51.0409ZM16.4837 67H14.9837C14.9837 67.5984 15.3394 68.1396 15.8887 68.377C16.4381 68.6143 17.076 68.5024 17.5117 68.0923L16.4837 67ZM16.4837 51.0409H17.9837C17.9837 50.2125 17.3121 49.5409 16.4837 49.5409V51.0409ZM30.4375 7.32353C31.2659 7.32353 31.9375 6.65196 31.9375 5.82353C31.9375 4.9951 31.2659 4.32353 30.4375 4.32353V7.32353ZM68.5 34.5C68.5 33.6716 67.8284 33 67 33C66.1716 33 65.5 33.6716 65.5 34.5H68.5ZM32.4122 49.9486L15.4556 65.9077L17.5117 68.0923L34.4683 52.1332L32.4122 49.9486ZM17.9837 67V51.0409H14.9837V67H17.9837ZM16.4837 49.5409H10.125V52.5409H16.4837V49.5409ZM3.5 43.3939V13.4706H0.5V43.3939H3.5ZM58.875 49.5409H33.4402V52.5409H58.875V49.5409ZM10.125 7.32353H30.4375V4.32353H10.125V7.32353ZM65.5 34.5V43.3939H68.5V34.5H65.5ZM58.875 52.5409C64.1038 52.5409 68.5 48.53 68.5 43.3939H65.5C65.5 46.7044 62.6209 49.5409 58.875 49.5409V52.5409ZM3.5 13.4706C3.5 10.16 6.37915 7.32353 10.125 7.32353V4.32353C4.89623 4.32353 0.5 8.33444 0.5 13.4706H3.5ZM10.125 49.5409C6.37915 49.5409 3.5 46.7044 3.5 43.3939H0.5C0.5 48.53 4.89623 52.5409 10.125 52.5409V49.5409ZM65.5 13.4706C65.5 18.8928 60.802 23.4412 54.8125 23.4412V26.4412C62.2849 26.4412 68.5 20.7184 68.5 13.4706H65.5ZM54.8125 23.4412C48.823 23.4412 44.125 18.8928 44.125 13.4706H41.125C41.125 20.7184 47.3401 26.4412 54.8125 26.4412V23.4412ZM44.125 13.4706C44.125 8.04836 48.823 3.5 54.8125 3.5V0.5C47.3401 0.5 41.125 6.22276 41.125 13.4706H44.125ZM54.8125 3.5C60.802 3.5 65.5 8.04836 65.5 13.4706H68.5C68.5 6.22276 62.2849 0.5 54.8125 0.5V3.5Z"
                    fill="currentColor"
                  />
                </svg>

                <Typography
                  component={"div"}
                  margin={0}
                  padding={0}
                  variant={"body1"}
                  fontWeight={600}
                >
                  Push Notification
                </Typography>
                <Typography
                  component={"div"}
                  margin={0}
                  padding={0}
                  variant={"body2"}
                >
                  Approve sign-ins via push notifications sent to the ID.me
                  Authenticator mobile application.
                </Typography>
              </Box>
            )}
            {generatorData?.length > 0 && (
              <Box
                className={"iconCheckbox"}
                onClick={() => {
                  dispatch(setSetup("1"));
                  dispatch(setSteps("three"));
                  setIsBack(false);
                }}
              >
                <svg
                  className="icon"
                  width="69"
                  height="69"
                  viewBox="0 0 69 69"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15 28V21.5C15 10.7425 18.25 2 34.5 2C50.75 2 54 10.7425 54 21.5V28"
                    stroke="currentColor"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M50.75 67H18.25C5.25 67 2 63.75 2 50.75V44.25C2 31.25 5.25 28 18.25 28H50.75C63.75 28 67 31.25 67 44.25V50.75C67 63.75 63.75 67 50.75 67Z"
                    stroke="currentColor"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M47.4885 47.5001H47.5177"
                    stroke="currentColor"
                    stroke-width="6"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M34.4853 47.5001H34.5145"
                    stroke="currentColor"
                    stroke-width="6"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M21.4821 47.5001H21.5113"
                    stroke="currentColor"
                    stroke-width="6"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>

                <Typography
                  component={"div"}
                  margin={0}
                  padding={0}
                  variant={"body1"}
                  fontWeight={600}
                >
                  Authenticator
                </Typography>
                <Typography
                  component={"div"}
                  margin={0}
                  padding={0}
                  variant={"body2"}
                >
                  Generate verification codes via code generator apps like ID.me
                  Authenticator application.
                </Typography>
              </Box>
            )}
            {generatorData?.length < 0 && pushData?.length < 0 && (
              <Typography
                component={"div"}
                margin={0}
                padding={0}
                variant={"body1"}
                fontWeight={600}
              >
                No Authentications presented
              </Typography>
            )}
          </Box>
        </Grid>
        <Grid item xs={12} textAlign="center">
          <Typography variant="body2" component="div">
            Having trouble signing in? Try another{" "}
            <Typography
              color="primary"
              style={{ cursor: "pointer", textDecoration: "underline" }}
              variant="body2"
              display={"inline"}
              onClick={() => {
                dispatch(setSteps("one"));
                setIsBack(false);
              }}
            >
              ways for authentication.
            </Typography>
          </Typography>
        </Grid>
      </Grid>
    </>
  );
}
